<template>
  <div class="content">
    <div class="image-text_1 flex-row justify-between">
      <div class="box_8 flex-col"></div>
      <span class="text-group_1">董事长致辞</span>
      <div class="group_2 flex-col"></div>
    </div>
    <div class="contentMain" v-html="content"></div>
  </div>
</template>

<script>
export default {
  name: "ChairmanSpeech",
  data() {
    return {
      content:''
    }
  },
  methods: {
    //获取董事长致辞文本
    getData() {
      var _this = this;
      _this.$api.get(
          "/Client/getChairmanSpeech",
          {},
          function (res) {
            if (res.code == "200") {
              _this.content = res.data.about_content;
            }
          }
      );
    }
  },
  mounted() {
    let that = this;
    that.getData();
  },
}
</script>

<style scoped>
.content{
  width: 1120px;
}
.contentMain{
  position: relative;top: 100px;
  min-height: 500px;
}
.image-text_1 {
  width: 141px;
  height: 48px;
  position: relative;
  top: 88px;
}
.text-group_1 {
  width: 104px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 26px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  line-height: 26px;
  margin-top: 11px;
}
.group_2 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/aboutSailHero/img/y_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
  margin-left: 22px;
}

.box_8 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/aboutSailHero/img/z_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
  margin-left: 485px;
}
</style>
